/* eslint-disable react/jsx-no-duplicate-props */
/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import MKButton from "components/MKButton";

// Images
// import aboutUsIcon from "assets/images/aboutus.svg";
import pricelistQr from "assets/images/pricelist-qr.png";

function ChooseUs() {
  return (
    <MKBox component="section" py={6} mx={-2} bgColor="light">
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} md={5}>
            <MKBox position="relative" textAlign="center">
              <MKBox
                component="img"
                src={pricelistQr}
                alt="Your trusted plumbing services"
                width="80%"
                objectFit="cover"
                objectPosition="50% 50%"
              />
            </MKBox>
          </Grid>
          <Grid item md={7}>
            <MKTypography variant="h2">Transparent Pricing. Trusted Service</MKTypography>
            <MKTypography variant="body2" color="text">
              Scan the QR code to view our full list of plumbing and repair services — clearly
              priced, with no hidden fees. At Hee Plumbing & Sanitary Specialist Pte Ltd, we believe
              in honest work and fair rates, backed by years of experience and satisfied customers.
            </MKTypography>
            <Grid container item xs={12} lg={12} my={3}>
              <Grid item xs={12} md={4}>
                <DefaultCounterCard count={500} suffix="+" title="Houses Serviced" />
              </Grid>
              <Grid item xs={12} md={4} sx={{ display: { md: "flex" } }}>
                <Divider
                  orientation="vertical"
                  sx={{ display: { xs: "none", md: "block" }, mx: 0 }}
                />
                <DefaultCounterCard
                  key={`counter-${new Date().getFullYear()}`}
                  count={new Date().getFullYear() - 1999}
                  title="Years Combined Experience"
                />
              </Grid>
              <Grid item xs={12} md={4} sx={{ display: { md: "flex" } }}>
                <Divider
                  orientation="vertical"
                  sx={{ display: { xs: "none", md: "block" }, mx: 0 }}
                />
                <DefaultCounterCard count={100} suffix="%" title="Client Satisfaction" />
              </Grid>
            </Grid>
            <MKButton
              component="a"
              href="https://drive.google.com/drive/folders/14FbENnWakYNRuJtd-z7lRck30LU9ZOZt"
              target="_blank"
              rel="noopener noreferrer"
              color="info"
              size="medium"
              fullWidth
            >
              See Our Services & Rates
            </MKButton>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ChooseUs;
